export const REGISTER_SECTION = "REGISTER_SECTION";
export const REGISTER_SECTION_ID = "REGISTER_SECTION_ID";
export const REGISTER_SECTION_INDEX_IF_NEEDED = "REGISTER_SECTION_INDEX_IF_NEEDED";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const REMOVE_QUESTION = "REMOVE_QUESTION";
export const USER_REMOVE_QUESTION = "USER_REMOVE_QUESTION";
export const QUESTIONNAIRE_LOADED = "QUESTIONNAIRE_LOADED";
export const SUBMIT_QUESTIONNAIRE_SUCCESS = "SUBMIT_QUESTIONNAIRE_SUCCESS";
export const SUBMIT_INVALID_QUESTIONNAIRE = "SUBMIT_INVALID_QUESTIONNAIRE";
export const TOGGLE_SECTION = "TOGGLE_SECTION";
export const OPEN_SECTION = "OPEN_SECTION";
export const NEXT_SECTION = "NEXT_SECTION";
export const CLEAR_QUESTIONNAIRE = "CLEAR_QUESTIONNAIRE";
export const RESET_ACTIVE_SECTIONS = "RESET_ACTIVE_SECTIONS";
export const VALIDATE_QUESTION_COMPLETE = "VALIDATE_QUESTION_COMPLETE";
export const SAVE_QUESTIONNAIRE_SUCCESS = "SAVE_QUESTIONNAIRE_SUCCESS";
export const REMOVE_SECTION = "REMOVE_SECTION";
